export default function removeURLParameter(query, parameter) {
    if (!query) return '';

    const prefix = `${encodeURIComponent(parameter)}=`;
    const params = query.split(/[&;]/g);

    // return the original search string without the parameter
    return params.filter((param) => {
        return param.indexOf(prefix) === -1;
    }).join('&');
}
